module.exports = __webpack_public_path__ + "img/icon-button-upload.3dc41e26.svg";